module.exports = __webpack_public_path__ + "static/TT1383_TW-MARK-D01a-clean-c3e8501e6de2634e923c390aa96ce169.png";